import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Calendar, Clock } from 'lucide-react';
import ParchmentBackground from '../../components/ParchmentBackground';
import '../../styles/BlogPage.css';

// All blog posts (newest first)
export const POSTS = [
  {
    slug: 'why-i-built-icraftz',
    title: 'Why I Built iCraftz',
    subtitle: 'One question, ₹199, and 49 books that changed everything',
    excerpt:
      'In December 2024, a ₹199 online course and one devastating question — "What happens to you if you read one book a week?" — set everything in motion.',
    author: 'Ashesh Thanawala',
    date: 'April 2026',
    readTime: '4 min read',
    category: "Founder's Voice",
    cover: 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=1200&auto=format&fit=crop&q=80',
  },
];

const BlogIndexPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Blog — iCraftz';
  }, []);

  return (
    <div className="legal-page">
      <ParchmentBackground />
      <header className="legal-topbar legal-topbar--split">
        <a
          href="https://icraftz.com"
          className="legal-home-link"
          data-testid="blog-topbar-logo"
        >
          iCraftz<sup>™</sup>
        </a>
        <a
          href="https://icraftz.com"
          className="legal-topbar-back"
          data-testid="blog-back-home-top"
        >
          <ArrowLeft size={14} /> Back to Home
        </a>
      </header>

      <main className="legal-main">
        <article className="legal-article">
          <p className="legal-eyebrow">JOURNAL</p>
          <h1 className="legal-title">The iCraftz Blog</h1>
          <p className="legal-subtitle">Stories, ideas and notes on books, growth and language.</p>
          <div className="legal-divider" />

          <div className="blog-grid">
            {POSTS.map((p, i) => (
              <Link
                key={p.slug}
                to={`/blogs/${p.slug}`}
                className={`blog-card${i === 0 ? ' blog-card--featured' : ''}`}
                data-testid={`blog-card-${p.slug}`}
              >
                <div className="blog-card-image">
                  <img src={p.cover} alt={p.title} />
                  <span className="blog-card-pill">{p.category}</span>
                </div>
                <div className="blog-card-body">
                  <h2 className="blog-card-title">{p.title}</h2>
                  <p className="blog-card-subtitle">{p.subtitle}</p>
                  <p className="blog-card-excerpt">{p.excerpt}</p>
                  <div className="blog-card-meta">
                    <span><Calendar size={12} /> {p.date}</span>
                    <span><Clock size={12} /> {p.readTime}</span>
                  </div>
                  <span className="blog-card-readmore">
                    Read post <ArrowRight size={14} />
                  </span>
                </div>
              </Link>
            ))}
          </div>

          <div className="legal-back-home-wrap">
            <a
              href="https://icraftz.com"
              className="legal-back-home-link"
              data-testid="blog-back-home-bottom"
            >
              ← Back to Home
            </a>
          </div>
        </article>
      </main>

      <footer className="legal-foot">
        <p>
          <Link to="/about">About</Link>
          <span> · </span>
          <Link to="/mission">Mission</Link>
          <span> · </span>
          <Link to="/partner">Partner</Link>
          <span> · </span>
          <Link to="/for-authors">For Authors</Link>
          <span> · </span>
          <Link to="/contact">Contact</Link>
          <span> · </span>
          <Link to="/privacy">Privacy</Link>
          <span> · </span>
          <Link to="/terms">Terms</Link>
        </p>
        <p className="legal-foot-copy">© {new Date().getFullYear()} iCraftz™. Less Noise · More Thought.</p>
      </footer>
    </div>
  );
};

export default BlogIndexPage;
